"use strict";
/*!
 *
 *  top.ts
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
function caseStudy() {
    var $casestudy = $('.top_casestudy');
    if ($casestudy.length) {
        var $items = $casestudy.children('.top_casestudy_item');
        var len_1 = $items.length;
        var $row_1 = [
            $('<div class="top_casestudy_row"></div>'),
            $('<div class="top_casestudy_row"></div>')
        ];
        var w_1 = [0, 0];
        $items.each(function (i, elem) {
            var _w = $(elem).outerWidth();
            if (i < len_1 / 2) {
                $row_1[0].append(elem);
                w_1[0] += _w;
            }
            else {
                $row_1[1].append(elem);
                w_1[1] += _w;
            }
            ;
        });
        $row_1.forEach(function ($elem, i) {
            for (var i_1 = 0; i_1 < 2; i_1++) {
                var $childrem = $elem.children().clone();
                $elem.append($childrem);
            }
            ;
            var $container = $('<div class="top_casestudy_container" />');
            $container.append($elem);
            $casestudy.append($container);
            if (i < 1) {
                $elem.css({
                    width: w_1[0] * 4
                }).addClass('-backwords');
            }
            else {
                $elem.css({
                    width: w_1[1] * 4
                }).addClass('-forwards');
            }
            ;
        });
        $(window).on('resize', function () {
            $row_1.forEach(function ($elem, i) {
                var _w = 0;
                $elem.each(function (i, elem) {
                    _w += $(elem).outerWidth();
                });
                $elem.css('width', _w);
            });
        });
    }
    ;
}
exports.caseStudy = caseStudy;
;
